import { Box, ButtonNew, Spacer, BoxProps } from '@jfs/ui-new'
import { tableItemStrings } from '../../data/static/strings'
import { ActionType } from './types'

const getDownloadAsView = (executeOnAction: (actionType: ActionType) => void, container: BoxProps) => {
  const csvDownload = () => {
    executeOnAction(ActionType.DownloadSettlementCSV)
  }
  return (
    <Box {...container}>
      <ButtonNew onPress={csvDownload} testID="btn-csvDownload" icon={'DOWNLOAD'}>
        {tableItemStrings.csv}
        <Spacer direction={'horizontal'} size={5} />
      </ButtonNew>
      <Spacer direction={'horizontal'} size={20} />
      <ButtonNew disabled onPress={csvDownload} testID="btn-pdfDownload" icon={'DOWNLOAD'}>
        {tableItemStrings.pdf}
        <Spacer direction={'horizontal'} size={5} />
      </ButtonNew>
    </Box>
  )
}

export { getDownloadAsView }
